<div *ngIf="searchState?.results && searchState.results.length > 0">
  <div class="results-list">
    <app-search-result-card
      *ngFor="let item of results$ | async; trackBy: trackByItem; index as i"
      [index]="i"
      [item]="item"
      [imageHeight]="313"
      [imageWidth]="313"
      (feedbackChange)="onFeedback($event, i + 1)"></app-search-result-card>
  </div>
</div>

<ng-container *ngIf="!searchState?.loading && (!searchState?.results || searchState.results.length === 0) && !searchState?.error">
  <div class="state-container state-container--compact">
    <mat-icon >search</mat-icon>
    <h2 class="state-title">Search Reality</h2>
    <p class="state-description">Use the search box above to find specific features in aerial imagery using AI-powered semantic search</p>
    @if ((geofencingValidation$ | async); as geofencing) {
      @if (!geofencing.valid) {
        <p class="state-description">{{ geofencing.reason }}</p>
        <button matButton="tonal" color="primary" (click)="openGeofencingDialog()">
          <mat-icon>crop_free</mat-icon>
          Configure geofencing
        </button>
      }
    }
  </div>
</ng-container>

<!-- Infinite Scroll Info Panel -->
<div
  *ngIf="searchState?.hasMore && !searchState?.loading && !searchState?.error"
  class="state-container state-container--compact"
  appIntersectObserver
  (appIntersect)="onInfiniteScroll()">
  <p class="state-description">Loading more...</p>
</div>
<div class="state-container state-container--compact" *ngIf="searchState?.loading">
  <mat-spinner diameter="40" class="mb-4"></mat-spinner>
  <p class="state-description">Loading results...</p>
</div>
<div class="state-container state-container--compact" *ngIf="searchState?.error">
  <mat-icon class="landing-icon" [class]="SearchUtilsService.getErrorIconClass(searchState.errorType)">
    {{ SearchUtilsService.getErrorIcon(searchState.errorType) }}
  </mat-icon>
  <h3 class="state-title">{{ SearchUtilsService.getErrorTitle(searchState.errorType) }}</h3>
</div>
